import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Textarea from "sushiweb/InputTypes/Textarea";

import * as FeatureActions from "../../../store/actions/Feature";
import * as UserActions from "./../../../store/actions/User";
import * as DriverActions from "./../../../store/actions/DriverServices";
import { getInitialState, isValNull, parseString } from "../../../utils";
import {
  isValidated,
  filterObj,
  getReadableDateTime,
  isDSMDropdownEnabled,
  getSortedList,
} from "../../../utils";
import ChangeLogTableFields from "../../../constants/ChangeLogs/ChangeLogTableFields.json";
import CrossCircle from "sushiweb/Icons/all/CrossCircle";
import * as CarrierActions from "../../../store/actions/Carriers";
import ChangeLogList from "../../Common/ChangeLogList";
import Permission from "../../Common/Permission";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import NoFooterModal from "../../Common/NoFooterModal";
import Input from "sushiweb/InputTypes/Input";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import {
  BottomSectionModal,
  FlexContainer,
} from "../../../constants/assets/containers";
import Button from "sushiweb/Button";
import ConfirmationModal from "../../Common/ConfirmationModal";
import MultiSelectCheckboxDropdown from "../../Common/MultiSelectCheckboxDropdown";
import variables from "../../../constants/assets/variables";
import Checkbox from "sushiweb/InputTypes/Checkbox";
import InfiniteScrollDropdown from "../../Common/InfiniteScrollDropdown";
import Autocomplete from "@material-ui/lab/Autocomplete";
import * as Comparators from "../../../constants/FeatureToggle/Comparators";
import TextField from "@material-ui/core/TextField";
import PlusCircle from "sushiweb/Icons/all/PlusCircle";
import _, { value } from "lodash-es";
import TimePickerInput from "../../Common/TimePickerInput";
import { is } from "date-fns/locale";

const mandatoryFields = ["name", "scope", "featureOwners", "useCase"];
const disabledFieldsInEditState = ["name", "scope", "callingServices"];
const scopeOptions = [
  { key: "driver", label: "Driver" },
  { key: "merchant", label: "Merchant" },
  { key: "customer", label: "Customer" },
];
const statusOptions = [
  { key: 0, label: "Disable" },
  { key: 1, label: "Enable" },
  { key: 2, label: "Kill" },
  { key: 3, label: "Stable" },
];
const slotDriverOptions = [
  { key: true, label: "True" },
  { key: false, label: "False" },
];

const conditionTypeOptions = [
  { key: "service_id", label: "Delivery Services" },
  { key: "app_version", label: "App Version" },
  { key: "carrier_id", label: "Carrier ID" },
  { key: "validate_time", label: "Time" },
  { key: "source_id", label: "Source ID" },
  { key: "is_slot_driver", label: "Slot Driver" },
];

const comparatorOptions = [
  { key: Comparators.GT, label: "Greater than" },
  { key: Comparators.LT, label: "Less than" },
  { key: Comparators.EQ, label: "Equals to" },
  { key: Comparators.NOT_EQ, label: "Not equals to" },
  { key: Comparators.GTE, label: "Greater than and equals to" },
  { key: Comparators.LTE, label: "Less than and equals to" },
  { key: Comparators.IN, label: "In" },
  { key: Comparators.NOT_IN, label: "Not in" },
];

const validDeleteFeatureStatusLabels = ["Kill", "Stable"];
const validDeleteFeatureStatusKeys = statusOptions.reduce((prev, cur) => {
  if (validDeleteFeatureStatusLabels.includes(cur.label)) {
    prev.push(cur.key);
  }
  return prev;
}, []);

const validFeatureStatusToDeleteTogglesLabels = ["Kill", "Stable"];
const validFeatureStatusToDeleteTogglesKeys = statusOptions.reduce(
  (prev, cur) => {
    if (validFeatureStatusToDeleteTogglesLabels.includes(cur.label)) {
      prev.push(cur.key);
    }
    return prev;
  },
  []
);

export const FeatureFormModal = (props) => {
  const {
    modalState,
    handleClose,
    activeId,
    activeFeature,
    activeFilters,
    filterFields,
    currentPage,
    setStatus,
    getDriverServices,
    getDriverServiceByIds,
    getCarriersList,
  } = props;
  const allActions = MenuActionsMappings[MenuNames.FEATURE];
  const [initialState, setInitialState] = useState({
    name: "",
    scope: "",
    status: 0,
    setConditions: true,
    updatedAt: "",
    changes: [],
    cleanFtDb: false,
    conditions: "[]",
    conditionsList: [],
    featureOwners: [],
    useCase: "",
    callingServices: [],
  });

  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [dropDownModalState, setDropDownModalState] = useState(modalState);
  const [startTime, setStartTime] = useState("00:00:00");
  const [endTime, setEndTime] = useState("00:00:00");
  const slotDriverInitialState = useRef("");
  const [selectedCarrierIds, setSelectedCarrierIds] = useState([]);
  const [featureOwnerPartialString, setFeatureOwnerPartialString] =
    useState("");
  const carrierIds = useRef([]);
  const carrierIdOptions = useRef([]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (
      process.env.REACT_APP_ENV === "production" &&
      (modalState === "Edit" || modalState === "Add")
    ) {
      const prodSubmitConfirmationModal = window.confirm(
        "[PRODUCTION ENV] are you sure you want to make these changes?"
      );
      if (!prodSubmitConfirmationModal) return;
    }

    let formValues = { ...initialState };

    if (!formValues.featureOwners) formValues.featureOwners = [];
    if (featureOwnerPartialString !== "") {
      formValues.featureOwners = [
        ...formValues.featureOwners,
        featureOwnerPartialString,
      ];
    }
    formValues.featureOwners = convertEmailsToSmallCase(
      formValues.featureOwners
    );
    setFeatureOwnerPartialString("");
    setInitialState(formValues);

    const body = filterObj(formValues, [
      "name",
      "scope",
      "status",
      "cleanFtDb",
      "conditions",
      "setConditions",
      "featureOwners",
      "useCase",
    ]);
    //if filter button is clicked then apply filters
    if (modalState === "Filter") {
      let filters = {};
      for (let key of filterFields) {
        if (body[key] !== "") {
          filters[key] = body[key] + "";
        }
      }
      props.getFeatureList(filters).then((res) => {
        handleClose();
      });
    } else {
      //before hitting api, check if all validations like mandatory fields are satisfied
      let validatedState = isValidated(body, mandatoryFields);
      formValues.conditionsList.forEach((detailCondition) => {
        let err = conditionValueCheck(detailCondition);
        if (err != "") {
          validatedState = err;
          return;
        }
      });

      let err = validateFeatureName(body["name"]);
      if (err) {
        validatedState = err;
      }

      let checkFeatureOwners = validateFeatureOwners(body["featureOwners"]);
      if (checkFeatureOwners && !err) {
        validatedState = checkFeatureOwners;
      }

      if (modalState !== "Edit") {
        body.cleanFtDb = false;
      }
      let conditions = body["conditions"];

      // `conditions` should be in correct json format
      try {
        if (conditions === "") {
          conditions = "null";
        }
        const val = JSON.parse(conditions);
        body["conditions"] = val;
      } catch {
        validatedState = "value of `conditions` is not in correct JSON format";
      }
      if (validatedState === "validated") {
        props.createFeature(body).then((res) => {
          let pageRequest = {
            page: currentPage,
          };
          props.getFeatureList(activeFilters, pageRequest);
          handleClose();
        });
      } else {
        setStatus({
          type: "error",
          message: validatedState,
        });
      }
    }
  };

  const handleClearFilters = () => {
    props.getFeatureList({}).then((res) => {
      props.resetState({ state: "activeFilters" });
      handleClose();
    });
  };

  const handleChange = (key, val, extraParams) => {
    let values = { ...initialState };
    values[key] = val;
    if (key == "scope") {
      values["conditions"] = "[]";
      values["conditionsList"] = [];
    } else if (key == "slot_driver") {
      handleConditionListChange("Value", val, extraParams[0]);
      return;
    }
    setInitialState(values);
  };

  const handleTimeChange = (key, value, extraParams) => {
    var start_time = startTime;
    var end_time = endTime;

    if (extraParams.type == "start") {
      start_time = value.format("HH:mm:ss");
      setStartTime(value ? value.format("HH:mm:ss") : "");
    }
    if (extraParams.type == "end") {
      end_time = value.format("HH:mm:ss");
      setEndTime(value ? value.format("HH:mm:ss") : "");
    }

    handleConditionListChange("Value", "validate_time", extraParams.index, {
      start_time: start_time,
      end_time: end_time,
    });
  };

  const handleCarrierIdChange = (key, val, index) => {
    setSelectedCarrierIds(val);
    const carrierIdsKeysArray = val.map((carrier_type) => {
      const option = carrierIdOptions.current.find(
        (item) => item.carrier_type === carrier_type
      );
      return option ? option.id : null;
    });
    carrierIds.current = carrierIdsKeysArray;
    handleConditionListChange("Value", "carrier_id", index.index, {
      carrier_ids: carrierIdsKeysArray,
    });
  };

  const handleConditionListChange = (key, val, index, obj) => {
    let values = { ...initialState };
    values.conditionsList[index][key] = val;
    if (key == "Name") {
      if (val == "app_version") {
        values.conditionsList[index]["Comparator"] = Comparators.GTE;
      } else if (val == "is_slot_driver") {
        values.conditionsList[index]["Comparator"] = Comparators.EQ;
      } else {
        values.conditionsList[index]["Comparator"] = Comparators.IN;
      }
      values.conditionsList[index]["Value"] =
        val == "app_version" || val == "service_id" || val == "carrier_id"
          ? []
          : "[]";

      if (val == "validate_time") {
        values.conditionsList[index]["Value"] = "00:00:00";
      }
    }
    if (
      key == "Comparator" &&
      values.conditionsList[index]["Name"] != "service_id"
    ) {
      values.conditionsList[index]["Value"] =
        val == Comparators.IN || val == Comparators.NOT_IN ? "[]" : "";
    }

    if (
      key == "Comparator" &&
      values.conditionsList[index]["Name"] == "carrier_id"
    ) {
      setSelectedCarrierIds([]);
    }
    setInitialState(values);
    // to set conditions
    let tempConditions = [];
    initialState.conditionsList.map((detailCondition, i) => {
      if (
        (detailCondition.Name !== "" &&
          detailCondition.Value !== "" &&
          detailCondition.Value !== "[]") ||
        (Array.isArray(detailCondition.Value) && detailCondition.Value.length)
      ) {
        if (detailCondition.Name == "validate_time") {
          {
            var newTime;
            if (obj && "start_time" in obj && "end_time" in obj) {
              newTime = [obj.start_time, obj.end_time];
            } else {
              newTime = [startTime, endTime];
            }
            detailCondition.Value = newTime;
            tempConditions = [...tempConditions, detailCondition];
          }
        } else if (detailCondition.Name == "carrier_id") {
          if (obj && "carrier_ids" in obj) {
            detailCondition.Value = obj.carrier_ids;
          } else {
            detailCondition.Value = carrierIds.current;
          }
          tempConditions = [...tempConditions, detailCondition];
        } else if (detailCondition.Name != "service_id") {
          try {
            let oldVal = _.cloneDeep(detailCondition.Value); // storing actual value
            detailCondition.Value = JSON.parse(detailCondition.Value); // parsing the value array
            let updatedDetailCondition = _.cloneDeep(detailCondition);
            tempConditions = [...tempConditions, updatedDetailCondition]; // update the parsed value in conditions
            detailCondition.Value = oldVal; // storing back the old value
          } catch {
            tempConditions = [...tempConditions, detailCondition];
          }
        } else {
          tempConditions = [...tempConditions, detailCondition];
        }
      }

      // if condition value is not there, remove that condition
      if (
        detailCondition.Value === "" ||
        detailCondition.Value === "[]" ||
        (Array.isArray(detailCondition.Value) &&
          detailCondition.Value.length == 0)
      ) {
        tempConditions.splice(i, 1);
      }
    });
    if (Array.isArray(tempConditions) && tempConditions.length) {
      setInitialState((prevState) => {
        return {
          ...prevState,
          ["conditions"]: JSON.stringify(tempConditions),
        };
      });
    }
    if (Array.isArray(tempConditions) && tempConditions.length == 0) {
      setInitialState((prevState) => {
        return {
          ...prevState,
          ["conditions"]: JSON.stringify(tempConditions),
        };
      });
    }
  };

  const isFilterApplicable = (value) => {
    if (modalState === "Filter" && filterFields) {
      return !filterFields.includes(value) ? true : false;
    } else {
      return false;
    }
  };

  const checkIfDisabled = (key) => {
    if (activeFeature["isDeleted"]) {
      return true;
    }
    if (modalState === "Edit") {
      return disabledFieldsInEditState.includes(key) ? true : false;
    } else {
      return false;
    }
  };

  const getRequiredButtonPerms = (action = undefined) => {
    if (action !== undefined) {
      if (action === "DELETE") {
        return [allActions.DELETE];
      }
    }

    if (modalState === "Edit") {
      return [allActions.UPDATE];
    } else if (modalState === "Add") {
      return [allActions.CREATE];
    }
    return undefined;
  };

  const getInputLabel = (val, options, fromKey, toKey, isNumber) => {
    const activeEle = options.find(
      (item) => item[fromKey] === (isNumber ? parseInt(val) : val)
    );
    return !isValNull(activeEle) ? activeEle[toKey] : "";
  };

  const convertEmailsToSmallCase = (emails) => {
    return emails.map((email) => email.toLowerCase());
  };

  //reset feature list
  useEffect(() => {
    modalState == "Filter" && initialState.scope
      ? props.getFeatureList({ scope: initialState.scope }, { pageSize: 2000 })
      : props.resetState({ state: "featuresList" });
  }, [modalState, initialState.scope]);

  useEffect(() => {
    if (activeId) {
      props.getFeature(activeId);
    }
  }, [activeId, modalState]);

  useEffect(() => {
    getCarriersList().then((carriers_list) => {
      carrierIdOptions.current = carriers_list.carriers;
    });
  }, []);

  useEffect(() => {
    //set the initial state of form in modal
    if (activeFeature && modalState === "Edit") {
      let values = { ...initialState };
      Object.keys(values).map((key, idx) => {
        values[key] = activeFeature[key]
          ? activeFeature[key]
          : getInitialState(initialState, key);
      });
      values.setConditions = true;
      values.conditionsList =
        typeof values.conditions === "object"
          ? values.conditions
          : parseString(values.conditions);
      values.conditionsList =
        values.conditionsList == null || values.conditionsList == undefined
          ? []
          : values.conditionsList;

      setInitialState(values);
      values.conditionsList.forEach((condition) => {
        if (condition.Name == "validate_time") {
          setStartTime(condition.Value[0]);
          setEndTime(condition.Value[1]);
        }
        if (condition.Name == "is_slot_driver") {
          if (condition.Value == true) {
            slotDriverInitialState.current = "True";
          } else {
            slotDriverInitialState.current = "False";
          }
        }

        if (condition.Name == "carrier_id") {
          getCarriersList().then((carriers_list) => {
            carrierIdOptions.current = carriers_list.carriers;
            var carrierTypes = [];
            condition.Value.forEach((carrier_id) => {
              const carrier_type = carrierIdOptions.current.find(
                (key) => key.id === carrier_id
              ).carrier_type;
              carrierTypes.push(carrier_type);
            });
            setSelectedCarrierIds(carrierTypes);
            carrierIds.current = condition.Value;
          });
        }
      });
    }
    if (activeFilters && modalState === "Filter") {
      let values = { ...initialState };
      Object.keys(values).map((key, idx) => {
        values[key] = activeFilters[key] ? activeFilters[key] : "";
      });
      setInitialState(values);
    }
  }, [activeFeature, activeFilters]);

  const toggleConfirmModal = () => {
    setConfirmModalOpen(!confirmModalOpen);
  };

  const featureDeleteHandler = () => {
    const body = { featureId: activeId };

    props.deleteFeature(body).then((res) => {
      let pageRequest = {
        page: currentPage,
      };
      props.getFeatureList(activeFilters, pageRequest);
      handleClose();
    });
  };

  const isConditionTypeOptionDisabled = (option, conditionIndex) => {
    if (option == "Source ID" && initialState.scope == "driver") {
      return true;
    }
    if (option == "Slot Driver" && initialState.scope != "driver") {
      return true;
    }
    if (option == "Carrier ID" && initialState.scope != "driver") {
      return true;
    }

    let disable = false;
    initialState.conditionsList.forEach((conditionDetail, index) => {
      let conditionType = getInputLabel(
        conditionDetail.Name,
        conditionTypeOptions,
        "key",
        "label"
      );

      if (conditionType == option && index != conditionIndex) {
        disable = true;
      }
    });
    return disable;
  };

  const conditionValueCheck = (detailCondition) => {
    switch (detailCondition.Name) {
      case "app_version":
        if (detailCondition.Value == "") {
          return "";
        }
        try {
          const versionRegex = /^\d+\.\d+\.\d+$/;
          if (!versionRegex.test(detailCondition.Value)) {
            return "Not a valid app version";
          }
        } catch {
          return "Not a valid app version";
        }

        break;
    }
    return "";
  };

  const handleAddCondition = () => {
    setDropDownModalState("Add");
    const updatedInitialState = {
      ...initialState,
      conditionsList: [
        ...initialState.conditionsList,
        {
          Name: "",
          Comparator: "",
          Value: "",
        },
      ],
    };
    setInitialState(updatedInitialState);
  };

  const getModalButtons = () => {
    if (modalState === "Edit" && activeFeature["isDeleted"]) {
      return "";
    }

    return (
      <BottomSectionModal className="flex items-center justify-between">
        {modalState === "Filter" && (
          <Button
            data-testid="filterFeatureBtn"
            onClick={handleClearFilters}
            className="sushi-btn"
          >
            Clear
          </Button>
        )}
        <Permission requiredPerms={getRequiredButtonPerms()}>
          <Button
            data-testid="submitButton"
            className="sushi-btn"
            onClick={handleSubmit}
          >
            {modalState === "Filter" ? "Apply" : "Submit"}
          </Button>
        </Permission>
        <Permission requiredPerms={getRequiredButtonPerms("DELETE")}>
          {validDeleteFeatureStatusKeys.includes(activeFeature.status) &&
          modalState === "Edit" ? (
            <Button
              data-testid="deleteFeatureBtn"
              onClick={toggleConfirmModal}
              className="sushi-btn"
            >
              Delete
            </Button>
          ) : (
            ""
          )}
        </Permission>
      </BottomSectionModal>
    );
  };

  return (
    <>
      <NoFooterModal
        header={true}
        heading={`${modalState} Feature`}
        handleClose={handleClose}
        id="FeatureFormModal"
        modalButtons={getModalButtons()}
      >
        <PaginatedReactDropdown
          options={scopeOptions}
          data-testid="featureScope"
          labelKey="label"
          valueKey="key"
          labelWidth="8%"
          disabled={checkIfDisabled("scope")}
          value={getInputLabel(
            initialState.scope,
            scopeOptions,
            "key",
            "label"
          )}
          handleChange={handleChange}
          keyToChange="scope"
          placeholder="Scope"
          showCross={false}
          id="featureScopeDropdown"
        />
        {modalState == "Filter" ? (
          <Autocomplete
            value={initialState.name}
            onChange={(event, newValue) => {
              handleChange("name", newValue);
            }}
            disabled={checkIfDisabled("name")}
            closeIcon={false}
            data-testid="featureName"
            id="controllable-states-demo"
            options={getSortedList(
              props.featureList.filter((val) => !val["isDeleted"]),
              "name"
            )}
            style={{ width: 300 }}
            renderInput={(params) => (
              <TextField {...params} label="Feature Name" variant="outlined" />
            )}
          />
        ) : (
          <Input
            value={initialState.name}
            data-testid="featureName"
            id="sushi-input"
            disabled={checkIfDisabled("name")}
            onChange={(e) => handleChange("name", e)}
            label="Name"
          />
        )}
        <PaginatedReactDropdown
          options={statusOptions}
          data-testid="featureStatus"
          labelKey="label"
          valueKey="key"
          labelWidth="8%"
          disabled={isFilterApplicable("status")}
          value={getInputLabel(
            initialState.status,
            statusOptions,
            "key",
            "label",
            true
          )}
          handleChange={handleChange}
          keyToChange="status"
          placeholder="Status"
          showCross={false}
          id="featureStatusDropdown"
        />
        {modalState !== "Filter" && (
          <>
            <InfiniteScrollDropdown
              id="featureOwners"
              priorityFlag={true}
              modalState={dropDownModalState}
              keyName="featureOwners"
              labelKey="FeatureOwners"
              keyTypeToSet="FeatureOwners"
              label="Feature Owners (Work Email IDs : zomato.com/grofers.com)"
              handleChange={(key, _, __, val) =>
                handleChange(key, val) && setFeatureOwnerPartialString("")
              }
              multiple
              freeSolo
              makeNoInitialCall
              value={initialState.featureOwners || []}
              setPartialString={setFeatureOwnerPartialString}
            />
            <Input
              value={initialState.useCase}
              data-testid="useCase"
              id="sushi-input"
              onChange={(e) => handleChange("useCase", e)}
              label="Use Case / Documentation Link"
            />
          </>
        )}
        {modalState === "Edit" && (
          <InfiniteScrollDropdown
            id="callingServices"
            priorityFlag={true}
            modalState={dropDownModalState}
            keyName="callingServices"
            labelKey="CallingServices"
            keyTypeToSet="CallingServices"
            label="Calling Services"
            disabled={checkIfDisabled("callingServices")}
            multiple
            freeSolo
            makeNoInitialCall
            value={initialState.callingServices || []}
          />
        )}
        {initialState.conditionsList.length
          ? (modalState === "Edit" || modalState === "Add") &&
            initialState.scope != "" &&
            initialState.conditionsList.map((detailCondition, index) => {
              return (
                <ConditionSection>
                  <p className="sectionHeading">Condition {index + 1}</p>
                  <PaginatedReactDropdown
                    options={conditionTypeOptions}
                    data-testid={`featureConditionOption${index}`}
                    labelKey="label"
                    valueKey="key"
                    labelWidth="17%"
                    value={getInputLabel(
                      detailCondition.Name,
                      conditionTypeOptions,
                      "key",
                      "label",
                      false
                    )}
                    isOptionDisabled={isConditionTypeOptionDisabled}
                    extraParamsOptionDisable={[index]}
                    handleChange={handleConditionListChange}
                    keyToChange="Name"
                    extraParams={[index]}
                    placeholder="Condition Type"
                    showCross={false}
                    id={`featureConditionOption${index}`}
                  />
                  <PaginatedReactDropdown
                    options={comparatorOptions}
                    data-testid={`featureComparatorOption${index}`}
                    labelKey="label"
                    valueKey="key"
                    labelWidth="14%"
                    value={getInputLabel(
                      detailCondition.Comparator,
                      comparatorOptions,
                      "key",
                      "label",
                      true
                    )}
                    handleChange={handleConditionListChange}
                    keyToChange="Comparator"
                    extraParams={[index]}
                    isOptionDisabled={(option) => {
                      switch (initialState.conditionsList[index].Name) {
                        case "app_version":
                          return option == "In" || option == "Not in";
                        case "service_id":
                          return option != "In" && option != "Not in";
                        case "source_id":
                          return option != "In" && option != "Not in";
                        case "carrier_id":
                          return option != "In" && option != "Not in";
                        case "validate_time":
                          return option != "In" && option != "Not in";
                        case "is_slot_driver":
                          return option != "Equals to";
                        default:
                          return false;
                      }
                    }}
                    placeholder="Comparator"
                    showCross={false}
                    id={`featureComparatorOption${index}`}
                  />
                  {detailCondition.Name == "service_id" ? (
                    <InfiniteScrollDropdown
                      id={`driverServicesDropdown${index}`}
                      priorityFlag={true}
                      activeElement={detailCondition}
                      getActiveList={getDriverServices}
                      resKey="driver_services"
                      modalState={dropDownModalState}
                      keyName="Value"
                      labelKey="name"
                      getDataLabelKey="driver_services.name"
                      keyTypeToSet="id"
                      label="Delivery Services"
                      handleChange={handleConditionListChange}
                      extraParams={[index]}
                      getActiveItemById={getDriverServiceByIds}
                      multiple
                    />
                  ) : detailCondition.Name == "validate_time" ? (
                    <SetTimeSection>
                      <TimePickerInput
                        showSecond={true}
                        className="start-time-picker"
                        label="Start Time"
                        val={startTime}
                        handleChange={handleTimeChange}
                        keyToChange="time"
                        extraParams={{ type: "start", index: index }}
                      />
                      <TimePickerInput
                        showSecond={true}
                        className="end-time-picker"
                        label="End Time"
                        val={endTime}
                        handleChange={handleTimeChange}
                        keyToChange="time"
                        extraParams={{ type: "end", index: index }}
                      />
                      <CrossCircle
                        onClick={(e) => {
                          setStartTime("00:00:00");
                          setEndTime("00:00:00");
                          handleConditionListChange("Comparator", 4, index);
                        }}
                        className="cross"
                      />
                    </SetTimeSection>
                  ) : detailCondition.Name == "carrier_id" ? (
                    <MultiSelectCheckboxDropdown
                      options={carrierIdOptions.current}
                      key="id"
                      options_label="carrier_type"
                      selectedValues={selectedCarrierIds}
                      handleChange={handleCarrierIdChange}
                      keyToChange="personName"
                      width={565}
                      extraParams={{ index: index }}
                    />
                  ) : detailCondition.Name == "is_slot_driver" ? (
                    <SlotDriverSection>
                      <PaginatedReactDropdown
                        options={slotDriverOptions}
                        data-testid="is_slot_driver"
                        labelKey="label"
                        valueKey="key"
                        labelWidth="15%"
                        value={slotDriverInitialState.current}
                        handleChange={handleChange}
                        keyToChange="slot_driver"
                        placeholder="Slot Driver"
                        showCross={true}
                        id="featureScopeDropdown"
                        extraParams={[index]}
                      />
                    </SlotDriverSection>
                  ) : (
                    <Input
                      value={detailCondition.Value}
                      data-testid={`featureConditionValue${index}`}
                      id="sushi-input"
                      onChange={(e) =>
                        handleConditionListChange("Value", e, index)
                      }
                      errorMsg={conditionValueCheck(detailCondition)}
                      label={getInputLabel(
                        detailCondition.Name,
                        conditionTypeOptions,
                        "key",
                        "label",
                        false
                      )}
                    />
                  )}
                </ConditionSection>
              );
            })
          : null}
        {(modalState === "Edit" || modalState === "Add") &&
          initialState.scope != "" && (
            <>
              <AddConditionContainer justify={"flex-end"}>
                <div
                  className="flex delete-icon"
                  onClick={() => {
                    handleAddCondition();
                  }}
                >
                  <PlusCircle color={variables.red500} size={20} />
                  <span>
                    Add {initialState.conditionsList.length ? "another" : ""}{" "}
                    condition
                  </span>
                </div>
              </AddConditionContainer>
              {initialState.conditionsList.length !== 0 ? (
                <React.Fragment>
                  <p className="mb-20 ml-12 opacity-5 text-grey">
                    <b>This is the final condition to be sent:</b>
                  </p>
                  <Textarea
                    id="sushi-textarea"
                    data-testid="featureConditions"
                    borderColor={variables.primaryColor}
                    innerWidth="100%"
                    className="mb-20"
                    resize="none"
                    label="Conditions"
                    disabled={true}
                    value={initialState.conditions}
                  />
                </React.Fragment>
              ) : null}
            </>
          )}
        <Permission requiredPerms={[allActions.TOGGLE_DELETE]}>
          {validFeatureStatusToDeleteTogglesKeys.includes(
            initialState.status
          ) && modalState === "Edit" ? (
            <Checkbox
              value="cleanFtDb"
              color={variables.red500}
              checked={initialState.cleanFtDb}
              onChange={(val) => handleChange("cleanFtDb", val.cleanFtDb)}
              className="sushi-checkbox mb-28"
              label={"Clean Feature Toggle Database Entries"}
            />
          ) : (
            ""
          )}
        </Permission>
        {modalState === "Edit" && (
          <Input
            value={getReadableDateTime(initialState.updatedAt)}
            data-testid="updatedAt"
            id="sushi-input"
            disabled
            label="Updated At"
          />
        )}
        {/* change log list */}
        {modalState === "Edit" && (
          <ChangeLogList
            changes={initialState.changes}
            tableFields={ChangeLogTableFields}
          />
        )}
      </NoFooterModal>
      <ConfirmationModal
        open={confirmModalOpen}
        modalTitle="Delete Feature"
        onCofirmCancelHandler={toggleConfirmModal}
        onCofirmSuccessHandler={featureDeleteHandler}
        successButtonText="Delete"
        successButtonColor="secondary"
      >
        {`Are you sure to delete "${activeFeature.name}" feature?`}
      </ConfirmationModal>
    </>
  );
};

const ConditionSection = styled.div`
  .sectionHeading {
    letter-spacing: 0.18rem;
    color: ${variables.grey600};
    margin-bottom: 1.75rem;
    margin-top: 1rem;
    font-size: 5px;
  }
  border-top: 1px solid ${variables.grey200};
`;

const AddConditionContainer = styled(FlexContainer)`
  span {
    color: ${variables.red500};
    font-weight: 500;
    margin-left: 5px;
  }
  margin: 0 1.5rem 1.5rem 0;
`;

const SetTimeSection = styled.div`
   {
    display: flex;
  }
`;

const SlotDriverSection = styled.div`
   {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
`;

function mapStateToProps(state) {
  const { Feature } = state;
  return {
    activeFeature: Feature.activeFeature,
    activeFilters: Feature.activeFilters,
    currentPage: Feature.currentPage,
    featureList: Feature.featureList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createFeature: bindActionCreators(FeatureActions.createFeature, dispatch),
    getFeatureList: bindActionCreators(FeatureActions.getFeatureList, dispatch),
    getFeature: bindActionCreators(FeatureActions.getFeature, dispatch),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    resetState: bindActionCreators(FeatureActions.resetState, dispatch),
    deleteFeature: bindActionCreators(FeatureActions.deleteFeature, dispatch),
    getDriverServices: bindActionCreators(
      DriverActions.getDriverServices,
      dispatch
    ),
    getDriverServiceByIds: bindActionCreators(
      DriverActions.getDriverServiceByIds,
      dispatch
    ),
    getCarriersList: bindActionCreators(
      CarrierActions.getCarriersList,
      dispatch
    ),
  };
}

function validateFeatureName(input) {
  if (/\s/.test(input)) {
    return "Feature name should not contain spaces.";
  }
  if (/[^a-zA-Z0-9_]/.test(input)) {
    return "Feature name should not contain special characters.";
  }
  if (input.length > 100) {
    return "Feature name should not exceed 100 characters.";
  }
  return null;
}

function validateFeatureOwners(input) {
  if (input.length == 0) {
    return "Feature Owners cannot be empty";
  }

  const validDomains = ["@zomato.com", "@grofers.com", "@eternal.com"];
  for (let email of input) {
    if (
      !validDomains.some(
        (domain) =>
          email.endsWith(domain) &&
          email !== domain &&
          !email.includes("..") &&
          email[0] !== "." &&
          email[email.length - domain.length - 1] !== "."
      )
    ) {
      return "All Feature Owners must have valid work email IDs";
    }
  }

  return null;
}

export default connect(mapStateToProps, mapDispatchToProps)(FeatureFormModal);
